<template lang="pug">
     Button(
         @click="multiClearCache" 
         :loading="isLoading" 
         :shape="shape"
         :disabled="disabled"
         style="padding: 8px;"
     )
         img(
             src="/static/img/broom.svg"
             style="width: 16px;"
         )
</template>

<script>
import { _channelTest } from "@/api/notificationChannels";
import { purgeCache } from "@/api/edges";

export default {
    name: "ClearCacheBtn",
    components: {},
    data() {
        return {
            isLoading: false,
            confirmData: {
                clearPathPlaceHolder: this.$t("domainsetting.clearPathPlaceHolder"),
                clearSubdomainPlaceHolder: this.$t("domainsetting.clearSubdomainPlaceHolder"),
                actionSuccessText: this.$t("global.success"),
                actionFalseText: this.$t("global.error")
            }
        };
    },
    props: {
        selectedItems: { default: () => [] },
        disabled: { default: false },
        shape: { default: "circle" },
        groupName: { default: "" },
        isAppProfile: { default: false }
        // icon: { default: "md-refresh" }
    },
    watch: {},
    created() {},
    mounted() {},
    methods: {
        multiClearCache() {
            var self = this;
            let width = 420;
            if ("en-US" == this.$store.state.userPref.lang) {
                width = 550;
            }
            this.$Modal.confirm({
                cancelText: "關閉",
                width,
                render: (h) => {
                    // subdomain
                    const rootDomain = self.selectedItems.map((item) => item.replace("_wildcard", ""));
                    const clearSubdomainInput = h("div", { style: { "margin-bottom": "16px" } }, [
                        h("h3", this.$t("domainsetting.subdomain")),
                        h("p", { style: { padding: "4px 0" } }, self.confirmData.clearSubdomainPlaceHolder),
                        h("Input", {
                            props: {
                                value: this.subdomainInputVal,
                                autofocus: true,
                                placeholder: "www",
                            },
                            on: {
                                input: (val) => {
                                    this.subdomainInputVal = val;
                                },
                            },
                            },
                            [h("template", { slot: "append" }, [h("span", rootDomain)])]
                        ),
                    ]);
                    // path
                    const clearPathInput = h("div", { style: { "margin-bottom": "8px" } }, [
                        h("h3", this.$t("domainsetting.path")),
                        h("p", { style: { padding: "4px 0" } }, self.confirmData.clearPathPlaceHolder),
                        h("Input", {
                            props: {
                                value: this.pathInputVal,
                                autofocus: true,
                                placeholder: "/assets/template/",
                            },
                            on: {
                                input: (val) => {
                                    this.pathInputVal = val;
                                },
                            },
                        }),
                    ]);
                    const inputs = [clearPathInput];
                    const isClearSubdomainInputNeeded =
                        !self.isAppProfile && self.selectedItems.some((item) => item.startsWith("_wildcard"));
                    if (isClearSubdomainInputNeeded) {
                        inputs.unshift(clearSubdomainInput);
                    }
                    return inputs;
                },
                onOk: function() {
                    let purgeItems = self.selectedItems.map(e => {
                        return {
                            fqdnConfig:
                                e.startsWith("_wildcard") && self.subdomainInputVal
                                    ? e.replace("_wildcard", self.subdomainInputVal)
                                    : e,
                            key: self.pathInputVal || "",
                        };
                    });
                    self.isLoading = true;

                    let purgeData = {
                        groupName: self.groupName,
                        isAppProfile: self.isAppProfile,
                        purgeItems: purgeItems
                    };

                    purgeCache(purgeData)
                        .then(function(response) {
                            self.$Message.success(self.confirmData.actionSuccessText);
                            self.isLoading = false;
                            self.subdomainInputVal = "";
                            self.pathInputVal = "";
                        })
                        .catch(function(error) {
                            console.log(error);
                            self.$Message.error(self.confirmData.actionFalseText);
                            self.isLoading = false;
                            self.subdomainInputVal = "";
                            self.pathInputVal = "";
                        });
                }
            });
        }
    },
    computed: {},
    beforeDestroy() {}
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/ClearCacheBtn.vue